import { render, staticRenderFns } from "./holidayConfigRecord.vue?vue&type=template&id=6ff3803d"
import script from "./holidayConfigRecord.vue?vue&type=script&lang=js"
export * from "./holidayConfigRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports